import {percentage} from "@/lib/format.tsx";
import {CheckDetailsAlert} from "@/lib/queries/checks.ts";
import {IsItDownServiceStatus, PublicProfile, PublicProfileStats} from "@/lib/types/isitdown.ts";
import {getIntervalAlerts} from "@/pages/checks/analysis/overview/utils.ts";
import {State} from "@/pages/checks/constants.ts";

interface ParsedStats extends PublicProfileStats {
  intervalAlerts: CheckDetailsAlert[];
  state: State;
  uptimePercentage: string;
  since: string | null;
}

export const getParsedStats = (profile: PublicProfile, stats: PublicProfileStats): ParsedStats | null => {
  if (stats.intervals === null) {
    return null;
  }
  const intervalAlerts = getIntervalAlerts(stats.intervals);
  const isUp = profile.service_status !== IsItDownServiceStatus.DOWN;
  const state = isUp ? State.Up : State.Down;
  const uptimePercentage = percentage(stats.totals?.uptime_pct || (isUp ? 1 : 0));
  let since = stats.service_created_at;
  if (stats.latest_downtime?.is_currently_down) {
    since = stats.latest_downtime!.created_at.toString();
  } else if (stats.latest_downtime && stats.latest_downtime.ended_at) {
    since = stats.latest_downtime!.ended_at;
  }
  return {...stats, intervalAlerts, state, uptimePercentage, since};
};
